const isNumber = (e) => typeof e === 'number'
const isString = (e) => typeof e === 'string'
const isObject = (e) => typeof e === 'object'
const isNull = (e) => typeof e === null

const info_style = 'font-style: italic; font-weight: bold; color: yellow'
const warning_style = 'font-style: italic; font-weight: bold; color: green'
const error_style = 'font-style: italic; font-weight: bold; color: red'

const printInfo = function (msg, data = null) {
  // console.log(`%c${msg}`, info_style)
  // if (!isNull(data)) console.log(JSON.stringify(data))
}

const printWarnning = function (msg, data = null) {
  // console.log(`%c${msg}`, warning_style)
  // if (!isNull(data)) console.log(JSON.stringify(data))
}

const printError = function (msg, data = null) {
  // console.log(`%c${msg}`, error_style)
  // if (!isNull(data)) console.log(JSON.stringify(data))
}

const checkObjectParam = function (param, fn_name = '') {
  if (isObject(param)) {
    return true
  } else {
    // printError(`param is not object. at ${fn_name}`, param)
    return false
  }
}
